export default __webpack_public_path__ + "static/media/visit-card.ea4609cd.jpeg";